export enum EngagementEventTypeEnum {
    view = 'VIEW',
    like = 'LIKE',
    share = 'SHARE',
    reply = 'REPLY',
    quote = 'QUOTE'
}
